/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedHistoryRouteImport } from './routes/_protected/history'
import { Route as ProtectedSessionSessionIdRouteImport } from './routes/_protected/session/$sessionId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHistoryRoute = ProtectedHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSessionSessionIdRoute =
  ProtectedSessionSessionIdRouteImport.update({
    id: '/session/$sessionId',
    path: '/session/$sessionId',
    getParentRoute: () => ProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/history': typeof ProtectedHistoryRoute
  '/session/$sessionId': typeof ProtectedSessionSessionIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/history': typeof ProtectedHistoryRoute
  '/': typeof ProtectedIndexRoute
  '/session/$sessionId': typeof ProtectedSessionSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_protected/history': typeof ProtectedHistoryRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/session/$sessionId': typeof ProtectedSessionSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/history'
    | '/session/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/privacy'
    | '/terms'
    | '/history'
    | '/'
    | '/session/$sessionId'
  id:
    | '__root__'
    | '/_protected'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/_protected/history'
    | '/_protected/'
    | '/_protected/session/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/history': {
      id: '/_protected/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof ProtectedHistoryRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/session/$sessionId': {
      id: '/_protected/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof ProtectedSessionSessionIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedHistoryRoute: typeof ProtectedHistoryRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedSessionSessionIdRoute: typeof ProtectedSessionSessionIdRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedHistoryRoute: ProtectedHistoryRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedSessionSessionIdRoute: ProtectedSessionSessionIdRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
